import React from 'react';

const NewStatusBadge = ({count}) => {
    return (
        <div style={{display:"flex", padding:"10px", justifyContent:"center", alignItems:"center", background: "#1F5C29", borderRadius:"8px", width:"54px"}}>
           <span style={{color:"#FFF", fontFamily:"Roboto", fontSize:"12px", fontWeight:"500"}}>{`${count} New`}</span>
        </div>
    )
}
export default NewStatusBadge;